<template>
  <div class="d-flex flex-column justify-content-start align-items-center">
    <div v-for="({ id, name, createdAt }, i) in participants.slice(0, limit)" :key="id || i"
      class="d-flex flex-row justify-content-start align-items-center w-100">
        <span class="flex-fill">{{ name }}</span>
        <span>{{ createdAt | formatDateRelative({ addSuffix: true }) }}</span>
    </div>
    <div class="d-flex flex-row justify-content-end align-items-center w-100" v-if="participants.length > limit">
      <b-btn class="text-muted px-0" size="sm" v-b-modal="'event-participants-list'" variant="link">View All ({{ participants.length }})</b-btn>
      <b-modal id="event-participants-list" title="All Participants" hide-footer body-class="p-0" @show="() => page = 1">
        <b-table :fields="[ 'name', 'createdAt' ]" :items="participants" striped primary-key="id"
          class="m-0" thead-class="d-none" :current-page="page" :per-page="100">
            <template v-slot:cell(createdAt)="{ value }">{{ value | formatDateRelative({ addSuffix: true }) }}</template>
        </b-table>
        <div class="d-flex justify-content-center align-items-center" v-if="participants.length > 100">
          <b-pagination class="my-3" v-model="page" :per-page="100" :total-rows="participants.length"/>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    participants: {
      type: Array,
      default: () => ([]),
    },
    limit: {
      type: Number,
      default: 5,
    },
  },
  data: () => ({
    page: 1,
  }),
};
</script>



// WEBPACK FOOTER //
// src/components/referral-jam/ParticipantsList.vue